import { render, staticRenderFns } from "./EditParent.vue?vue&type=template&id=3a5da2e2&scoped=true&"
import script from "./EditParent.vue?vue&type=script&lang=js&"
export * from "./EditParent.vue?vue&type=script&lang=js&"
import style0 from "./EditParent.vue?vue&type=style&index=0&id=3a5da2e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5da2e2",
  null
  
)

export default component.exports